import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../base-component/base-component";

import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";
import Loading from "../../gd-ui/loading/loading";

import Classes from 'classnames';

export default class ModalOptionsSelection extends BaseComponent {

    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string
        })),
        onSelectOption: PropTypes.func
    };

    state = {
        options: this.props.options
    };

    setOptions(options) {
        this.setState({
            options: options
        })
    }

    onSelectOption = (id) => {
        if (this.props.onSelectOption) this.props.onSelectOption(id);
    };

    render() {
        return (
            <div className={Classes("gd-modal-options-selection", this.props.className)}>
                <VScroll>
                    {!this.state.options && <Loading />}

                    {this.state.options &&
                    <div className="modal-options-selection-container">
                        {this.state.options.map(item=>
                            <div key={item.id} className="modal-options-item" onClick={this.onSelectOption.bind(this,item.id)}>
                                <div className="modal-options-item-label">{item.label}</div>
                                <div className="gd-btn-arrow-right-blue-22 modal-options-item-arrow"/>
                            </div>)}

                        {this.props.children}
                    </div>}
                </VScroll>
            </div>
        )
    }
};